import type { HoldToggleEventPublisher } from '@usecases/hold-toggle.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export class HoldTogglePublisher implements HoldToggleEventPublisher {
  async publish(legId: string, putOnHold: boolean): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.HOLD',
      payload: {
        shouldHold: putOnHold,
        legId,
      },
    };

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
